import { render } from "./ProviderApprovalComponent.vue?vue&type=template&id=c450759a&scoped=true"
import script from "./ProviderApprovalComponent.vue?vue&type=script&lang=js"
export * from "./ProviderApprovalComponent.vue?vue&type=script&lang=js"

import "./ProviderApprovalComponent.vue?vue&type=style&index=0&id=c450759a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c450759a"]])

export default __exports__